import { render, staticRenderFns } from "./RegisterWithReferer.vue?vue&type=template&id=65f09a50&scoped=true&"
import script from "./RegisterWithReferer.vue?vue&type=script&lang=js&"
export * from "./RegisterWithReferer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterWithReferer.vue?vue&type=style&index=0&id=65f09a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f09a50",
  null
  
)

export default component.exports